import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'blackgranny.dating',
  TITLE: 'Granny Dating',
  NICHE: 'Black Granny',
  PROJECT: 'blackgrannydating',
  NICHE_SINGULAR: 'Black Granny',
  NICHE_PLURAL: "Black Granny's",
  COMPANY_NAME: 'infiniteconn.com',
  TYPE: 'adult',
  SENTRY_RELEASE: 'www-blackgranny-dating',
  SENTRY_DNS:
    'https://d83bde143e86ef08532c9c80a9bb9bdd@sentry.nearbyapi.com/13',

  VWO_ID: 302021,

  TABOOLA_TRACKING_PIXEL: '1800925',

});

export default config;
